
import Vue, { PropType } from 'vue';

import { ITreeNode } from '../Itree-node';
import { TreeNodeEventType } from '../tree-node-event-type';
import TuxTreeViewTable from './tux-tree-view-table.vue';
import TuxTreeViewPagedTable from './tux-tree-view-paged-table.vue';
import TuxTreeView from './tux-tree-view.vue';

interface ITableData {
	key: string;
	stickyColumn: boolean;
	label: string;
}

export default Vue.extend({
	name: 'TreeView',
	components: {
		TuxTreeViewTable,
		TuxTreeViewPagedTable,
		TuxTreeView
	},
	props: {
		value: {
			type: Array as PropType<Array<ITreeNode>>,
			required: false,
			default: () => []
		},
		selectedNodeId: {
			type: Number,
			required: false,
			default: null
		},
		displayType: {
			type: String,
			required: false,
			default: 'tree'
		},
		nodeColumnTitle: {
			type: String,
			required: false,
			default: 'Node'
		},
		nodeColumnSticky: {
			type: Boolean,
			required: false,
			default: true
		},
		searchBoxClass: {
			type: String,
			required: false,
			default: ''
		},
		draggable: {
			type: Boolean,
			required: false,
			default: false
		},
		allowMultipleRootNodes: {
			type: Boolean,
			required: false,
			default: true
		},
		preventNodeClickOverride: {
			type: Boolean,
			required: false,
			default: false
		},
		headerOffset: {
			type: Number,
			required: false,
			default: 300
		},
		openFirstVisibleNode: {
			type: Boolean,
			required: false,
			default: true
		},
		virtualScrollHeight: {
			type: Number,
			required: false,
			default: 0
		},
		pagedTableFields: {
			type: Array as PropType<Array<ITableData>>,
			default: () => [],
			required: false
		},
		pagedTableNodesPerPage: {
			type: Number,
			default: 20,
			required: false
		},
		initializeNodesOnValueChange: {
			type: Boolean,
			required: false,
			default: true
		}
	},
	data() {
		return {
			enums: { TreeNodeEventType },
			treeNodes: [] as ITreeNode[],
			currentPage: 1 as number,
			searchText: '' as string,
			isExpanded: false as boolean,
			SEARCH_DEBOUNCE: 200 as number
		};
	},
	computed: {
		displayTypeTable(): boolean {
			return this.displayType === 'table';
		},
		displayTypeTree(): boolean {
			return this.displayType === 'tree';
		},
		displayTypePagedTable(): boolean {
			return this.displayType === 'paged-table';
		}
	}
});
